module.exports = __webpack_public_path__ + "images/newerp_button2.1789608252531.png";